import { RestrictionContext } from '@src/context/RestrictionContext'
import { TrackType } from '@prisma/client'
import { useContext } from 'react'
import { WorkWithParsedSrts } from '@src/api/work/[id]'
import { useWebAudio } from '../lib/playerHooks'
import {
  AudioOff, AudioOn, Loader, AudioDescription
} from './icons'

export const AudioController: React.FC<{ work: WorkWithParsedSrts }> = ({ work }) => {
  const {
    webAudioIsPlaying,
    webAudioIsBuffering,
    toggleWebAudio,
  } = useWebAudio()

  const hasAudio = work.tracks?.length || work.audioUrl

  const { restricted } = useContext(RestrictionContext)
  const Icon = () => {
    if (webAudioIsBuffering) { return <Loader /> }
    return webAudioIsPlaying ? <AudioOn /> : <AudioOff />
  }
  return (
    <>
      <div className="button-group">
        {hasAudio
          && (
            <>
              {work.tracks[0]?.trackType === TrackType.AUDIO_DESCRIPTION && <span className="audio-description"><AudioDescription /></span>}
              <button
                type="button"
                disabled={webAudioIsBuffering || restricted}
                onClick={() => {
                  if (!webAudioIsBuffering) { toggleWebAudio() }
                }}
                aria-label={webAudioIsPlaying ? 'mute' : 'unmute'}
              >
                <Icon />
              </button>
            </>
          )}
      </div>
    </>
  )
}
